export const env = {
  siteName: process.env.REACT_APP_SITE_NAME || 'PathIQ SMB',
  api: process.env.REACT_APP_API_URL || 'https://dev-smbapi.path-iq.ai/api/v1',
  // NOTE: LLM calls are server-side only. Never ship an LLM API key to the browser.
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
  facebookAppId: process.env.REACT_APP_FACEBOOK_APP_ID || '',
  // Browser Maps JS key — inherently public; must be HTTP-referrer restricted in GCP.
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
  // Stripe *publishable* key — public by design. The secret key is server-side only.
  stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '',
};
